/*** IMPORTS FROM imports-loader ***/
var define = false;

// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

